import styled, { css } from "styled-components";

export const ContactWrapperStyle = styled.div`
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 767.98px) {
    height: 100%;
  }
`;

export const ModalWrapperStyle = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(143, 144, 146, 0.8);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 767.98px) {
    height: 100%;
  }
`;

export const ModalWrapperBorder = styled.div`
  background-color: #eceef2;
  width: 100%;
  max-width: 790px;
  height: 790px;
  margin: 30px;
  padding: 95px;
  padding-bottom: 50px;
  position: relative;

  form {
    z-index: 9999;
  }

  ${props => {
    if (props.contact) {
      return css`
        margin: 0;
        padding: 0;
        max-width: 100%;
      `;
    }
  }};

  @media (max-width: 767.98px) {
    height: 100%;
    margin: 0;
    /* padding: 60px 0 60px; */
    /* overflow-y: scroll; */
    padding: 60px 30px 60px;
    overflow-y: scroll;
  }

  > button {
    position: absolute;
    right: 25px;
    top: 25px;
    cursor: pointer;
    float: right;
    border: none;
    background-color: transparent;
    color: #ff5000;
    font-size: 20px;
    line-height: 20px;

    &:focus {
      outline: none;
    }
  }

  .form-desc {
    color: #8f9092;
    font-size: 9px;
    font-family: "Roboto Mono";
    line-height: 2;

    button {
      margin-bottom: 55px;
    }

    a {
      color: #000001;
      margin-left: 5px;
    }

    input[type="radio"],
    input[type="checkbox"] {
      display: none;
    }

    label {
      position: relative;
      color: #8f9092;
      font-family: "Roboto Mono";
      line-height: 2;
      padding-bottom: 10px;
    }
    .checkbox {
      display: inline-block;
      cursor: pointer;
      margin: 0 0 10px 0;
      padding-left: 30px;
    }

    .checkbox:before {
      content: "";
      display: inline-block;
      width: 20px;
      height: 20px;
      vertical-align: middle;
      background-color: #ffffff;
      border: 1px solid #8f9092;
      text-align: center;
      margin-right: 10px;
      position: absolute;
      left: 0;
      top: 3px;
    }

    input[type="checkbox"]:checked + .checkbox:before {
      color: #ffffff;
      background-color: #ffffff;
      padding-top: 5px;
    }

    .checkbox:after {
      content: "";
      display: inline-block;
      width: 10px;
      height: 10px;
      vertical-align: middle;
      background-color: white;
      text-align: center;
      margin-right: 10px;
      left: 5px;
      position: absolute;
      top: 8px;
    }

    input[type="checkbox"]:checked + .checkbox:after {
      color: #ffffff;
      background-color: #ff5000;
      padding-top: 5px;
    }

    .checkbox span {
      padding-left: 10px;
    }
  }
`;

export const ModalWrapperSteps = styled.div`
  display: flex;
  justify-content: space-between;
  background: black;
  font-size: 12px;
  font-weight: 500;

  span {
    flex: 1 1 0;
    padding: 9px;
    padding-left: 30px;
    font-family: "Roboto Mono";
    background-color: black;
    color: #8f9092;
    text-transform: uppercase;
    position: relative;

    @media (max-width: 767.98px) {
      padding-left: 10px;
    }

    :first-child {
      padding-left: 10px;
    }

    &:after {
      content: "";
      position: absolute;
      right: -13px;
      background-color: black;
      top: 5px;
      width: 26px;
      height: 26px;
      z-index: 1;
      transform: rotate(45deg);
      border-right: 1px solid white;
      border-top: 1px solid white;

      @media (max-width: 767.98px) {
        content: none;
      }
    }

    &:last-child {
      &:after {
        content: initial;
      }
    }

    &.active {
      background-color: #ff5000;
      color: #fff;

      &:after {
        background-color: #ff5000;
      }
    }
  }
`;
